export const enum MaskVariant {
  DEFAULT,
  LEFT,
}
